import { render, staticRenderFns } from "./organizer.vue?vue&type=template&id=54c5e200&scoped=true"
import script from "./organizer.vue?vue&type=script&setup=true&lang=ts"
export * from "./organizer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./organizer.vue?vue&type=style&index=0&id=54c5e200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c5e200",
  null
  
)

export default component.exports